export const formatToTwoDigits=( number )=>{

    let numberFormat="";
    if(number < 10) {
        numberFormat = "0" + number;
    }else{
        numberFormat = number;
    }

    return numberFormat;
}